<template>
    <div>
        <a-modal modal-id="bookmark-page-modal">
            <div slot="title">{{ isCurrentPageBookmarked ? 'Edit Bookmark' : 'Add Bookmark' }}</div>
            <div slot="form">
              <div class="row">
                <div class="m-t-sm">
                  <label>Name *</label>
                  <input type="text" v-model="bookmarkToEdit.name" class="form-control" placeholder="Name" @keydown.enter="saveBookmark">
                </div>
                <div class="m-t-sm">
                  <label>Tags</label>
                  <v-select multiple taggable push-tags v-model="bookmarkToEdit.tags" ref="tags"></v-select>
                </div>
              </div>
            </div>
            <div slot="footer">
              <div v-if="isCurrentPageBookmarked">
                <button class="btn btn-primary btn-sm" @click="saveBookmark"> <i class="fa fa-save"></i> Save</button>
                <button class="btn btn-danger btn-sm" @click="deleteBookmark(bookmarkToEdit)"><i class="fa fa-remove"></i> Delete bookmark</button>
              </div>
              <button v-else class="btn btn-primary btn-sm" @click="saveBookmark" :disabled="!bookmarkToEdit.name || !bookmarkToEdit.name.length">Create bookmark</button>
            </div>
        </a-modal>
        <span>
            <a v-if="isBookmarkedPage" @click="bookmarkToEdit = {...currentBookmark}"  data-toggle="modal" data-target="#bookmark-page-modal">
              <i v-tooltip="'Edit bookmark'" class="fas fa-bookmark"></i>
            </a>
            <a v-else @click="bookmarkToEdit = {}; bookmarkToEdit.path = currentWindowPathname;" data-toggle="modal" data-target="#bookmark-page-modal">
              <i v-tooltip="'Bookmark page'" class="far fa-bookmark"></i>
            </a>
        </span>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      bookmarksDisplayed: false,
      bookmarkToEdit: {},
      isCurrentPageBookmarked: false,
      currentWindowPathname: null,
      currentBookmark: {}
    }
  },
  computed: {
    ...mapGetters({
      bookmarks: 'getBookmarks'
    }),
    isBookmarkedPage () {
      return this.bookmarks.map(b => b.path).includes(this.currentWindowPathname)
    }
  },
  watch: {
    $route (to, from) {
      if (this.bookmarks.length) {
        this.currentBookmark = this.bookmarks.filter(b => b.path === to.fullPath)[0]
        this.isCurrentPageBookmarked = !!this.currentBookmark
      }
      this.currentWindowPathname = this.$route.fullPath
    }
  },
  mounted () {
    this.currentWindowPathname = this.$route.fullPath
    this.$store.dispatch('fetchBookmarks')
    if (this.bookmarks.length) {
      this.currentBookmark = this.bookmarks.filter(b => b.path === this.currentWindowPathname)[0]
      this.isCurrentPageBookmarked = !!this.currentBookmark
    }
  },
  methods: {
    async saveBookmark () {
      try {
        if (this.bookmarkToEdit.id) {
          await this.$store.dispatch('editBookmark', this.bookmarkToEdit)
          this.$toastr.success('Bookmark updated successfully')
        } else {
          await this.$store.dispatch('createBookmark', this.bookmarkToEdit)
          this.$toastr.success('Bookmark created successfully')
        }
        $('#bookmark-page-modal').modal('hide')
        await this.$store.dispatch('fetchBookmarks')
      } catch (error) {
        this.$toastr.error('Failed saving bookmark', error)
      }
    },
    async deleteBookmark (bookmark) {
      if (confirm(`Are you sure you want to delete ${bookmark.name} ?`)) {
        await this.$store.dispatch('deleteBookmark', bookmark.id)
        this.$toastr.success('Deleted bookmark successfully')
        $('#bookmark-page-modal').modal('hide')
        await this.$store.dispatch('fetchBookmarks')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/Bookmarks/BookmarkManager.vue